import React from 'react';
import {
  List,
  Edit,
  Datagrid,
  TextField,
  SimpleForm,
  EditButton,
  DateField,
  SelectInput,
  ReferenceField,
 } from 'react-admin';

export const MentoringTimeRequestList = props => (
  <List {...props}>
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <ReferenceField label="Timeslot starting time" source="timeslotId" reference="timeslots">
          <DateField label="Start time" source="starting" showTime/>
      </ReferenceField>
      <DateField label="End time" source="timeslot.ending" showTime/>
      <ReferenceField label="Student name" source="userId" reference="users">
        <TextField label="Student name" source="firstName" />
      </ReferenceField>
      <ReferenceField label="Mentor email" source="timeslot.mentor.user.id" reference="users">
        <TextField label="Mentor email" source="email" />
      </ReferenceField>
      <TextField label="Status" source="status" />
      <TextField disabled label="Request text" source="requestText" />
      <EditButton />
    </Datagrid>
  </List>
);

export const MentoringTimeRequestEdit = props => (
  <Edit {...props}>
    <SimpleForm>
        <TextField source="id" />
        <DateField disabled label="Start time" source="timeslot.starting" showTime/>
        <DateField disabled label="End time" source="timeslot.ending" showTime/>
        <TextField disabled label="Student name" source="user.firstName" />
        <TextField disabled label="Mentor email" source="timeslot.mentor.user.email" />
        <SelectInput
          label="status"
          source="status"
          choices={[
            { id: 'pending', name: 'pending' },
            { id: 'accepted', name: 'accepted' },
            { id: 'rejected', name: 'rejected' },
          ]}
        />
        <TextField disabled label="Request text" source="requestText" />
    </SimpleForm>
  </Edit>
);
